import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  calendarContainer: {
    '& .MuiPickersLayout-root': {
      display: 'block',
    },
    '& .MuiStaticDatePicker-root': {
      '& .MuiPickerStaticWrapper-content': {
        '& .MuiCalendarPicker-root': {
          minHeight: 'auto',
        },
        '& .MuiCalendarPicker-viewTransitionContainer': {
          '& > div': {
            minHeight: 'auto',
          },
        },
        '& .MuiPickersCalendarHeader-root': {
          paddingBottom: theme.spacing(1),
          marginBottom: 0,
        },
        '& .MuiDayPicker-header': {
          marginBottom: theme.spacing(0.5),
        },
        '& .MuiDayPicker-monthContainer': {
          '& .MuiDayPicker-weekContainer': {
            margin: 0,
          },
        },
      },
    },
    // Override all MUI date picker day styles
    '& .MuiPickersDay-day': {
      margin: theme.spacing(0.25),
      width: 38,
      height: 38,
      borderRadius: '4px',
      backgroundColor: 'transparent',
      color: `${theme.new.color.textPrimary}`,
      '&:hover': {
        backgroundColor: `${theme.new.color.grey[300]}`,
        borderRadius: '4px',
      },
    },
    '& .MuiPickersDay-day.Mui-selected': {
      backgroundColor: `${theme.new.color.textPrimary}`,
      color: `${theme.new.color.common.white}`,
      '&:hover': {
        backgroundColor: `${theme.new.color.grey[800]}`,
        borderRadius: '4px',
      },
    },
    '& .MuiPickersDay-daySelected': {
      backgroundColor: `${theme.new.color.textPrimary}`,
      color: `${theme.new.color.common.white}`,
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: `${theme.new.color.grey[800]}`,
        borderRadius: '4px',
      },
      '&:focus': {
        backgroundColor: `${theme.new.color.textPrimary}`,
        borderRadius: '4px',
      },
    },
    '& .MuiPickersDay-root': {
      width: 38,
      height: 38,
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: `${theme.new.color.grey[300]}`,
        borderRadius: '4px',
      },
      '&.Mui-selected': {
        backgroundColor: `${theme.new.color.textPrimary}`,
        color: `${theme.new.color.common.white}`,
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: `${theme.new.color.grey[800]}`,
          borderRadius: '4px',
        },
      },
    },
    '& .MuiPickersDay-root:hover:not(.Mui-selected)': {
      backgroundColor: `${theme.new.color.grey[300]}`,
      borderRadius: '4px',
    },
  },
  dateBadge: {
    '& .MuiBadge-badge': {
      backgroundColor: theme.new.color.textPrimary,
      width: 4,
      height: 4,
      minWidth: 4,
      borderRadius: '50%',
      bottom: 3,
      top: 'auto',
      left: '50%',
      right: 'auto',
      transform: 'translateX(-50%)',
    },
  },
  dateBadgeSelected: {
    '& .MuiBadge-badge': {
      backgroundColor: `${theme.new.color.common.white}`,
    },
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    paddingTop: 0,
    color: theme.new.color.textPrimary,
    marginTop: theme.spacing(-1),
  },
}));

export default useStyles;
